import * as bootstrap from "bootstrap";
window.bootstrap = bootstrap;
import { ChiUtil } from "../../admin/chi_util.js";
window.ChiUtil = ChiUtil;
import Swiper from "swiper/bundle";
window.Swiper = Swiper;
import MediaZoom from "../../shared/media-zoom.min";
window.MediaZoom = MediaZoom;
import Tags from "../../shared/tags";
window.Tags = Tags;
